var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcs2Plug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 93,
    viewBox: "0 0 64 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_20192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8829 6.70953C50.7209 4.15993 47.4979 2.69727 44.0346 2.69727H20.8796C17.1494 2.69727 13.6862 4.40818 11.384 7.40061C7.7139 12.1643 5.77208 17.8741 5.77208 23.926C5.77208 38.7607 17.7033 50.8243 32.3637 50.8243C47.0241 50.8243 59.429 38.8747 59.429 24.181C59.429 17.9076 57.1002 11.7014 52.8762 6.70953H52.8829Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8829 6.70953C50.7209 4.15993 47.4979 2.69727 44.0346 2.69727H20.8796C17.1494 2.69727 13.6862 4.40818 11.384 7.40061C7.7139 12.1643 5.77208 17.8741 5.77208 23.926C5.77208 38.7607 17.7033 50.8243 32.3637 50.8243C47.0241 50.8243 59.429 38.8747 59.429 24.181C59.429 17.9076 57.1002 11.7014 52.8762 6.70953H52.8829Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3357 12.8353C50.1737 10.2857 46.9507 8.823 43.4874 8.823H20.3324C16.6022 8.823 13.139 10.5339 10.8368 13.5263C7.16672 18.2901 5.2249 23.9998 5.2249 30.0518C5.2249 44.8864 17.1561 56.95 31.8165 56.95C46.4769 56.95 58.8819 45.0005 58.8819 30.3067C58.8819 24.0334 56.553 17.8271 52.3291 12.8353H52.3357Z",
    fill: "#172228"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0346 22.6847H20.8796C17.1494 22.6847 13.6862 24.3956 11.384 27.388C9.82921 29.4009 8.59472 31.5882 7.67386 33.8895C11.5975 43.7994 21.1865 50.8175 32.3637 50.8175C43.5408 50.8175 53.4034 43.9336 57.4338 34.1981C56.3395 31.5211 54.8047 28.9849 52.8762 26.7037C50.7142 24.1541 47.4912 22.6914 44.0279 22.6914L44.0346 22.6847Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.8314 4.77715C52.4625 1.9793 48.9259 0.375732 45.1356 0.375732H19.7518C15.6613 0.375732 11.8645 2.25438 9.34209 5.52861C5.31832 10.7486 3.18966 17.0085 3.18966 23.6442C3.18966 39.9012 16.2686 53.1323 32.3437 53.1323C48.4187 53.1323 62.0181 40.0287 62.0181 23.926C62.0181 17.0488 59.4691 10.2454 54.8314 4.77715ZM32.3503 49.375C18.3439 49.375 6.98655 37.8817 6.98655 23.7046C6.98655 17.7533 8.98842 12.2783 12.3382 7.9306C14.1733 5.54874 16.9959 4.13304 19.9921 4.13304H44.8954C47.5846 4.13304 50.2004 5.24681 51.942 7.30662C55.7256 11.7751 58.2146 17.6392 58.2146 23.9797C58.2146 38.1568 46.3501 49.375 32.3437 49.375H32.3503Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0181 23.926C61.8513 18.129 59.9562 12.4528 56.6998 7.73602C55.0916 5.40113 53.2499 3.14003 50.6275 1.95917C48.0384 0.6374 45.1757 0.704495 42.3197 0.751461L25.0301 0.664238L20.7061 0.610562C16.382 0.322055 12.0913 2.10006 9.34876 5.5286C11.8778 1.94575 16.342 -0.0738042 20.6994 0.140899L25.0235 0.0872231L42.313 0C43.7544 0.0268379 45.1824 -0.0536758 46.6704 0.107352C49.6132 0.449535 52.4358 1.79143 54.4978 3.93846C59.3623 9.3463 62.1916 16.6328 62.0115 23.9327L62.0181 23.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2212 23.9797C58.7017 38.0494 46.23 49.8849 32.4304 49.744C18.444 49.9386 6.5061 37.7475 6.98655 23.6979C7.12668 30.4141 9.90262 36.9826 14.6204 41.639C30.3351 57.319 57.6741 46.2283 58.2212 23.973V23.9797Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.766 30.5111C40.9088 27.3511 40.9088 22.2278 37.766 19.0678C34.6233 15.9078 29.5278 15.9078 26.3851 19.0678C23.2423 22.2278 23.2423 27.3511 26.3851 30.5111C29.5278 33.671 34.6233 33.671 37.766 30.5111Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1043 18.1693C43.0783 18.1693 45.4893 15.7451 45.4893 12.7548C45.4893 9.76438 43.0783 7.34021 40.1043 7.34021C37.1302 7.34021 34.7192 9.76438 34.7192 12.7548C34.7192 15.7451 37.1302 18.1693 40.1043 18.1693Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9892 18.1693C26.9632 18.1693 29.3742 15.7451 29.3742 12.7548C29.3742 9.76438 26.9632 7.34021 23.9892 7.34021C21.0151 7.34021 18.6041 9.76438 18.6041 12.7548C18.6041 15.7451 21.0151 18.1693 23.9892 18.1693Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2528 92.9999C56.6598 92.9999 62.225 87.3841 63.613 79.8829C61.6044 73.5626 56.4529 69.0605 49.8267 69.0605H15.3277C7.92076 69.0605 2.7359 73.9048 1.33458 81.406C3.34981 87.733 8.11427 92.9999 14.7472 92.9999H49.2462H49.2528Z",
    fill: "#172228"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0231 88.1692H17.9835C8.38786 88.1692 0.573871 80.6077 0.0533834 71.0936C0.0333646 71.4291 0 71.7579 0 72.1C0 82.0837 8.04754 90.1821 17.9835 90.1821H46.0231C55.9525 90.1821 64.0067 82.0905 64.0067 72.1C64.0067 71.7579 63.9733 71.4291 63.9533 71.0936C63.4328 80.6077 55.6188 88.1692 46.0231 88.1692Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.4759 88.6523H10.8902C6.20582 88.6523 2.99614 82.0971 2.40892 80.1246V67.3162C2.40892 62.6061 7.52038 57.4667 12.2048 57.4667L51.6417 57.943C56.3261 57.943 60.9571 62.6061 60.9571 67.3095V80.1179C60.9571 84.8279 57.1603 88.6456 52.4759 88.6456V88.6523Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5436 54.917H16.6289C7.44698 54.917 0 62.4048 0 71.637V73.784C0 83.4591 7.80065 91.2958 17.4163 91.2958H47.3711C56.533 91.2958 63.96 83.8281 63.96 74.616V72.422C63.96 62.7469 56.1593 54.9103 46.5436 54.9103V54.917ZM60.9838 73.7371C61.0105 80.6344 56.8466 87.4378 49.5598 87.941H15.1142C9.64905 87.941 3.48994 81.7616 3.00949 73.7371V71.5766C2.99614 64.4377 9.14858 57.9497 15.1475 57.9497H47.7648C55.1117 57.9497 60.6435 64.6793 60.9505 71.0935L60.9838 73.7371Z",
    fill: "#4C6672"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3034 81.473C30.5537 77.1994 30.5537 70.2706 26.3034 65.997C22.0531 61.7234 15.162 61.7234 10.9117 65.997C6.66145 70.2706 6.66145 77.1994 10.9117 81.473C15.162 85.7465 22.0531 85.7465 26.3034 81.473Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6576 83.8491C56.2109 81.5362 58.848 75.1348 56.5477 69.5512C54.2475 63.9675 47.881 61.3159 42.3277 63.6288C36.7744 65.9416 34.1373 72.343 36.4376 77.9267C38.7378 83.5104 45.1043 86.1619 50.6576 83.8491Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.8243 82.6674C24.5403 82.6674 29.174 78.1645 29.174 72.6099C29.174 67.0553 24.5403 62.5524 18.8243 62.5524C13.1083 62.5524 8.47461 67.0553 8.47461 72.6099C8.47461 78.1645 13.1083 82.6674 18.8243 82.6674Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8243 78.0312C21.9053 78.0312 24.4029 75.6041 24.4029 72.61C24.4029 69.6159 21.9053 67.1887 18.8243 67.1887C15.7434 67.1887 13.2458 69.6159 13.2458 72.61C13.2458 75.6041 15.7434 78.0312 18.8243 78.0312Z",
    fill: "url(#paint0_linear_6_20192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0567 30.6422C36.2543 30.6422 39.6572 27.3348 39.6572 23.255C39.6572 19.1753 36.2543 15.8679 32.0567 15.8679C27.8591 15.8679 24.4563 19.1753 24.4563 23.255C24.4563 27.3348 27.8591 30.6422 32.0567 30.6422Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1606 23.2551C36.1606 25.4558 34.3255 27.2405 32.0634 27.2405C29.8013 27.2405 27.9662 25.4558 27.9662 23.2551C27.9662 21.0544 29.8013 19.2697 32.0634 19.2697C34.3255 19.2697 36.1606 21.0544 36.1606 23.2551Z",
    fill: "url(#paint1_linear_6_20192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9892 16.6999C26.9632 16.6999 29.3742 14.3539 29.3742 11.4598C29.3742 8.5658 26.9632 6.21973 23.9892 6.21973C21.0151 6.21973 18.6041 8.5658 18.6041 11.4598C18.6041 14.3539 21.0151 16.6999 23.9892 16.6999Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8986 11.4598C26.8986 13.0164 25.5973 14.2845 23.9958 14.2845C22.3943 14.2845 21.0931 13.0231 21.0931 11.4598C21.0931 9.89651 22.3943 8.63513 23.9958 8.63513C25.5973 8.63513 26.8986 9.89651 26.8986 11.4598Z",
    fill: "url(#paint2_linear_6_20192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1043 16.6999C43.0783 16.6999 45.4893 14.3539 45.4893 11.4598C45.4893 8.5658 43.0783 6.21973 40.1043 6.21973C37.1302 6.21973 34.7192 8.5658 34.7192 11.4598C34.7192 14.3539 37.1302 16.6999 40.1043 16.6999Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.007 11.4598C43.007 13.0164 41.7058 14.2845 40.1043 14.2845C38.5028 14.2845 37.2015 13.0231 37.2015 11.4598C37.2015 9.89651 38.5028 8.63513 40.1043 8.63513C41.7058 8.63513 43.007 9.89651 43.007 11.4598Z",
    fill: "url(#paint3_linear_6_20192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4903 82.6674C52.2062 82.6674 56.84 78.1645 56.84 72.6099C56.84 67.0553 52.2062 62.5524 46.4903 62.5524C40.7743 62.5524 36.1405 67.0553 36.1405 72.6099C36.1405 78.1645 40.7743 82.6674 46.4903 82.6674Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4902 78.0312C49.5712 78.0312 52.0688 75.6041 52.0688 72.61C52.0688 69.6159 49.5712 67.1887 46.4902 67.1887C43.4093 67.1887 40.9117 69.6159 40.9117 72.61C40.9117 75.6041 43.4093 78.0312 46.4902 78.0312Z",
    fill: "url(#paint4_linear_6_20192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7458 54.9774H23.3752L23.4153 50.8175H41.7925L41.7458 54.9774Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7121 70.4897C62.6654 63.9882 58.1879 57.5605 51.5216 56.2857C48.7657 55.7423 44.4684 56.0643 41.6057 55.9972C34.3856 56.0442 23.7823 56.0107 16.5889 55.9838C7.52038 55.2324 0.68731 61.6667 0.467103 70.4964C0.273589 61.4856 7.34689 54.6956 16.5889 55.3665C23.7689 55.333 34.3989 55.3062 41.6057 55.3531C44.5551 55.4538 48.7524 55.1049 51.6484 55.7557C58.4615 57.1781 62.9924 63.8742 62.7188 70.5031L62.7121 70.4897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9438 75.6761C61.2307 81.9696 56.6731 88.0752 50.1937 88.5113C48.6389 88.6254 47.1509 88.5717 45.6228 88.5985C42.7601 88.612 34.9461 88.6388 31.9766 88.6522C28.9805 88.6388 21.2332 88.612 18.3305 88.5985C16.8024 88.5717 15.301 88.7998 13.7596 88.5113C8.96841 87.6123 2.70921 81.151 3.00281 74.8575C3.09623 77.8969 4.75112 81.1041 6.7263 83.3719C8.64811 85.6732 11.7577 87.7129 13.8063 87.9276C17.056 88.2631 31.99 88.1624 31.99 88.1624C38.0423 88.1758 44.1214 87.9611 50.1403 87.9276C56.3995 87.6458 60.9171 81.7817 60.9371 75.6694L60.9438 75.6761Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_20192",
    x1: 18.8243,
    y1: 78.0312,
    x2: 18.8243,
    y2: 67.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_20192",
    x1: 32.0567,
    y1: 27.2405,
    x2: 32.0567,
    y2: 19.2697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_20192",
    x1: 23.9892,
    y1: 14.2845,
    x2: 23.9892,
    y2: 8.64184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_20192",
    x1: 40.1043,
    y1: 14.2845,
    x2: 40.1043,
    y2: 8.64184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_20192",
    x1: 46.4902,
    y1: 0.0000473003,
    x2: 46.4902,
    y2: 0.0000473003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_20192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs2Plug);
export default __webpack_public_path__ + "static/media/ccs2_plug.1d076cbcd12504776733ec1dd7573cf4.svg";
export { ForwardRef as ReactComponent };